import { queryKeyFactory } from "@l2r-front/l2r-query"

export const INCIDENTS_ROOT_QUERY_KEY = "incidents"

export const incidentsQueryKeys = queryKeyFactory(INCIDENTS_ROOT_QUERY_KEY, {
    project: (filters = {}) => [INCIDENTS_ROOT_QUERY_KEY, "project", filters] as const,
    network: (filters = {}) => [INCIDENTS_ROOT_QUERY_KEY, "network", filters] as const,
})
